<template>
  <div class="ArchiveDetalsFlow pa-2">
    <box :type="'level-2'" :title="getTitle()">
      <div class="pa-2">
        <v-data-table
          dense
          :headers="headers"
          :items="list"
          hide-default-footer
          hide-default-header
          disable-pagination
          class="text-rtl"
        />
      </div>
    </box>
    <!-- <div> -->
      <!-- <label  v-if="externalFlow">
        {{ $t("notExistFlow") }}
      </label> -->
    <!-- </div> -->
    
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";

export default {
  props: {
    pageNo: String,
    pageType: Number,
    year: Number,
    // externalFlow:Boolean,
  },
  data() {
    return {
      list: [],
      headers: [
        {
          text: this.$t("description"),
          value: "comment",
        },
      ],
      
    };
  },
  watch:{
    pageNo(){
       this.getPageWorkflow();
    }
  },
  mounted() {
    this.getPageWorkflow();
  },
  methods: {
    getTitle() {
      if (this.pageType === 1) {
        return this.$t("vacationFlow");
      } else if (this.pageType === 2) {
        return this.$t("missionFlow");
      } else if (this.pageType === 3) {
        return this.$t("ioFlow");
      } else if (this.pageType === 4) {
        return this.$t("extraworkFlow");
      } else if (this.pageType === 5) {
        return this.$t("specificExtraworkFlow");
      } else {
        return "";
      }
    },
    getPageWorkflow() {
      debugger;
      
        this.list = [];
        let params = new URLSearchParams();
        params.append("pageNo", TextUtils.convertToEnglishDigits(this.pageNo));
        params.append(
          "pageType",
          TextUtils.convertToEnglishDigits(this.pageType)
        );
        params.append("year", TextUtils.convertToEnglishDigits(this.year));

        this.$store.dispatch("getPageWorkflow", { params }).then((result) => {
          //console.log(result);
          debugger;
          if (result.type === ResultType.success) {
            debugger;
            this.list = result.data.Table;
          }
        });
    
    },
  },
};
</script>

<style>
</style>